import { useState } from "react";
import "./PasswordEmailEntry.css";
import { forgotPassword } from "../../../redux/actions/loginRecoveryActions";
import { useDispatch } from "react-redux";
import { getPublicUrl } from '../../../utilities/env';


export default function ResetPassword() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!email || !email.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setSubmitted(true);
    dispatch(forgotPassword(email));
  };

  return (
    <div className="page">
      <img src={`${getPublicUrl()}/Status_Solutions_Logo-Header.svg`} alt="Status logo" className="statusLogo" />
      <div className="blob1" />
      <div className="blob2" />

      <div className="card">
        <h2 className="title">Reset Password</h2>
        <p className="subtitle">
          Email address must be valid and associated to one user profile.
        </p>

        {submitted ? (
          <div className="successBox">
            <p className="successText">
              ✓ If that email is registered to one user profile, you'll receive reset instructions shortly.
            </p>
            <button className="linkBtn" onClick={() => setSubmitted(false)}>
              Try a different email
            </button>
          </div>
        ) : (
          <>
            <div className="fieldGroup">
              <label className="label" htmlFor="email">
                Email Address:
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                placeholder=""
                className="inputEmail"
              />
              {error && <p className="errorText">{error}</p>}
            </div>

            <button className="submitBtn" onClick={handleSubmit}>
              SEND RESET LINK
            </button>

            <div className="linksRow">
              <a href="/index.php" className="linkToLogin">
                Back to Login
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

